import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Ticket } from "lucide-react";
import { NAV_LINKS } from "@/lib/data";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="navbar"
      className="fixed w-full top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-100"
    >
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-2 font-heading font-extrabold text-xl text-[#2C3E50]"
        >
          <span className="grid place-items-center w-9 h-9 rounded-xl bg-[#FF6B35] text-white">
            <Ticket size={18} />
          </span>
          Tixter<span className="text-[#FF6B35]">.nl</span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `font-medium text-sm transition-colors ${
                  isActive ? "text-[#FF6B35]" : "text-slate-600 hover:text-[#FF6B35]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/concerttickets"
          data-testid="navbar-cta"
          className="hidden md:inline-flex bg-[#FF6B35] hover:bg-[#E55A2A] text-white font-semibold rounded-full px-6 py-2.5 text-sm transition-all hover:-translate-y-0.5 shadow-md"
        >
          Bekijk Deals
        </Link>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-slate-700"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-slate-100 px-4 py-4 space-y-1">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block py-2 font-medium ${isActive ? "text-[#FF6B35]" : "text-slate-700"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>
      )}
    </header>
  );
}
